import React from 'react';
import './editorial-code-of-conduct.m.css';
const EditorialCodeOfConduct = () => {
  return (
    <div className="container" styleName="main-container">
      <h3>Code of Conduct - NDTV Profit</h3>
      &nbsp;
      <div>
        <h4>Mission:</h4>
        <ul styleName="ulist">
          <li>
            Quintillion Business Media Quintillion Business Media (Hereinafter referred to as “QBM)
            expects all the Editorial Employees to abide by the highest journalistic standards in
            order to protect the reputation of the Company and its brand.
          </li>
          &nbsp;
          <li>
            It will be the responsibility of the Journalists to provide accurate and unbiased
            reports at all times. It makes certain its employees comply with all applicable legal
            requirements and restrictions and avoids conflicts of interest (real or perceived) that
            may tarnish their work or reputation.
          </li>
        </ul>
        <p styleName="core-mail">
          The Editorial Code of Conduct is shared below. Any feedback or grievances should be shared
          on <a href="mailto:profiteditor@ndtv.com">editor@ndtv.com.</a>
        </p>
      </div>
      <h5>Core Principles</h5>
      <p styleName="core-para">
        The overarching message is to avoid conflicts of interest -- actual, potential or perceived
        -- political, financial or personal. Never be deceptive, duplicitous or dishonest in
        gathering and reporting news. Never break the law. Write accurately and fairly, without bias
        or agenda of any kind, other than to provide news that readers need and want. Correct any
        errors promptly and completely.
      </p>
      &nbsp;
      <div>
        <div>
          <p>
            1. <b>ACCURACY</b>
          </p>
          <p styleName="main-para">
            is the most important word in journalism. It's the foundation for any media
            organization's reputation. Never sacrifice this principle. If you get it wrong, people
            won't trust you to get it right. That means losing viewers and readers as well as access
            to newsmakers and sources.
          </p>
        </div>
        &nbsp;
      </div>
      <div>
        <h5>How to get it right</h5>
        &nbsp;
        <h5>Fact-checking:</h5>
        <p styleName="core-para">
          All reporters should check their work before filing to their editors: Double check all
          proper names and titles. Double check all numbers and calculations. Check with reporting
          notes to make sure all quotations are accurate. Also run spell check to catch typos and
          grammatical errors.
        </p>
        <p>
          An editor should also run the traps to ensure work is accurate before publishing it. Raise
          any red flags for discussion with the reporter before hitting the button.
        </p>
        <h5>How do we know what we know?</h5>
        <p styleName="core-para">
          Reporters and editors must verify the facts and check the credibility of their sources.
          Facts taken from old stories must be rechecked and updated. Take the time to check the
          people, institutions and web sites where you collect information. If you suspect the
          statement isn't genuine or a source isn't credible, don't publish any story. Call to
          confirm authenticity and explain to the readers who the source is. Err on the side of
          caution. Accuracy is more important than speed.
        </p>
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
      </div>
      <div>
        &nbsp; &nbsp;
        <p>
          2. <b>CORRECTIONS</b>
        </p>
        <p styleName="main-para">
          QBM expects its Editorial Staff to act quickly to correct errors and to be transparent in
          doing so. Owning up to one's errors is crucial to maintaining the trust of readers and
          viewers. Clearly label corrections. Never hide them. Flag any errors to your editor and
          manager so everyone's aware.
        </p>
        <p styleName="correction-para">
          Correct any story that has a factual error, however small, and explain precisely in a
          story trash line what was corrected. Discuss with your manager how best to correct any
          errors. Delete all stories or video content containing factual errors only AFTER a
          correction is published.
        </p>
        <div styleName="list-para">
          <p styleName="sub-heading">Always correct factual errors, including:</p>
          <ul styleName="ulist">
            <li>
              misspelled names, proper nouns or any words that change the meaning of a sentence.
            </li>
            &nbsp;
            <li>
              incorrect numbers, including wrong dates, confused million and billion, misplaced
              commas in figures, mistakes in calculations.
            </li>
            &nbsp;
            <li>
              missing first references (e.g., a story says "xxx, said Blogs", omitting the first
              name, Joe); and incorrect attribution.
            </li>
            &nbsp;
          </ul>
          <p styleName="sub-heading">
            As a rule, do not remove a piece from the Web without first clearly sending a correction
            or an ignore message.
          </p>
          <div>
            <ul styleName="ulist-circle">
              <li>
                <p>
                  Grammar, syntax and punctuation errors, typographical errors in ordinary words
                  (including transposed or dropped letters) and dropped words that don't make the
                  story wrong can be fixed with an on-screen editor without calling attention to the
                  change.
                </p>
              </li>
              <li>
                <p>
                  <b>Trashlines:</b> When correcting a story or video, add a trashline at the bottom
                  of the item clearly explaining what was corrected. When updating an item, keep a
                  reference to the earlier correction in the trashline. Also use a trashline to
                  explain if you are adding new information to a story or video. If an item is
                  changed, the reader must be told what change has been made.
                </p>
              </li>
              <li>
                <p>
                  <b>Headlines, deks and straps:</b> Take care in crafting headlines, decks and
                  blurbs on the Web or TV. Do not write headlines that are stronger than what's
                  reported in any story or video. Do not bait readers with headlines that don't
                  accurately reflect what the story or video is about.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      &nbsp;
      <div>
        <p>
          3. <b>BALANCE AND FAIRNESS: </b>
        </p>
        <p styleName="main-para">
          Every story MUST have a comment or no comment from the participants we mention. Do not
          submit stories without first placing those calls. Be clear and direct with sources and
          firms, telling them what the story is about. Lay out clearly everything we've done to seek
          comment. Don't use imprecise phrases such as "couldn't be reached". Instead, explain the
          efforts made to reach each person. Say clearly
        </p>
        <ul styleName="ulist-circle">
          <li>
            <p>
              When a story includes an accusation or information that may be considered defamatory
              or unfair, it's even more essential that we call the person or institution for a
              response. Weigh the seriousness of the allegation/ruling against the effort we've made
              to seek comment. Once we've made a reasonable effort to get the comment, publish the
              story whether we get comment or not. A defamatory statement is one that damages the
              reputation of a person, company, government or institution. Or makes others think less
              of them. It's possible for headlines, stories, photos, video and on-air chat to be
              defamatory.
            </p>
          </li>
        </ul>
      </div>
      &nbsp;
      <div>
        <p>
          4. <b>ANONYMOUS SOURCES:</b>
        </p>
        <p styleName="main-para">
          Always prefer to depend on fully identified sources. It will give credibility to your work
          by being transparent in where your information comes from.
        </p>
        <ul styleName="ulist-circle">
          <li>
            <p>
              In cases where it's necessary to depend on unidentified sources, seek approval to do
              so from your manager. Any source must have direct, first-hand knowledge of the facts.
              Have a conversation about the source's motives and trustworthiness: How do they know
              the information? Why are they telling us? Do they have an ax to grind? Why don't they
              want to be identified? Are they reliable? This conversation will help determine how
              much more reporting is needed, and whether to use the source.
            </p>
          </li>
          <li>
            <p>
              Efforts must be made to corroborate the facts with other people and where possible,
              documents. Stay alert and sceptical to holes in the source's story -- and be
              transparent about them in the report. Give all people and companies named in the
              report an opportunity to respond before broadcast or publication.
            </p>
          </li>
          <li>
            <p>
              Once a decision is made to attribute information to an anonymous source, be as
              transparent as possible to readers and viewers about who the source is and how they
              know what they know. Push for attribution that is specific: a person briefed on the
              meeting; people who have seen the documents; executives who were briefed on the
              negotiations.
            </p>
          </li>
          <li>
            <p>
              Note that the person asked not to be identified and why, justifying to readers the use
              of an unnamed source.
            </p>
          </li>
          <li>
            <p>
              When the use of unnamed sources is approved, make clear in the story that the people
              requested that they not be identified.
            </p>
          </li>
          <li>
            <p>
              Avoid using unattributed quotations. Paraphrase, or find someone else to quote
              directly.
            </p>
          </li>
        </ul>
      </div>
      &nbsp;
      <div>
        <p>
          5. <b>ATTRIBUTION:</b>
        </p>
        <p styleName="main-para">
          Readers, listeners and viewers won’t trust what we say without the proof of definitive
          attribution. Failure to cite our sources can lead to inaccurate and incomplete stories.
        </p>
        <ul styleName="ulist-circle">
          <li>
            <p>
              Be precise with attribution. Hearing an anecdote from an executive who attended a
              conference isn’t the same as being in the room. Talking to an investor who has read a
              research report isn’t reading the report yourself. Avoid attributing an economist’s
              view of a policy decision as if it were the government’s motivation for the action.
            </p>
          </li>
          <li>
            <p>
              In general, the attribution should appear high up in a story. For government
              background briefings with other media in attendance we can say: A ministry official
              told reporters (and explain why they did not want to be named).
            </p>
          </li>
          <li>
            <p>
              When summarizing reports from other media groups, always give them credit for their
              work. Only summarize reports from trusted media with a proven track record. Before
              publishing, read the whole report to make sure you're comfortable they have the
              reporting to back up their facts. Explain what the source of their information is.
              Work quickly to get comment from any person or company implicated in wrongdoing before
              you publish or broadcast the summary. Show in your work that you made an effort to get
              comment.{' '}
            </p>
          </li>
        </ul>
      </div>
    </div>
  );
};

export { EditorialCodeOfConduct };
